document.addEventListener('DOMContentLoaded', function () {
  var productContainer = document.querySelector('#gridContainer'); // ✅ Contenedor real de productos
  var nextPageElem = document.querySelector('#FoodlyNextPage');

  console.log('[InfiniteScroll] productContainer encontrado (#gridContainer):', !!productContainer);
  console.log('[InfiniteScroll] nextPageElem encontrado:', !!nextPageElem);

  if (!productContainer) return;

  var nextPageUrl = nextPageElem ? nextPageElem.getAttribute('data-next-url') : null;
  var loading = false;

  console.log('[InfiniteScroll] nextPageUrl inicial:', nextPageUrl);

  function isSoldOutProduct(productEl) {
    // En tu HTML: <a class="product__link ... product--sold-out" ...>
    return !!productEl.querySelector('.product__link.product--sold-out');
  }

  function getFirstSoldOutInDOM() {
    // Devuelve el primer producto vendido ya insertado en el DOM (si existe)
    var children = productContainer.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.classList && el.classList.contains('product') && isSoldOutProduct(el)) {
        return el;
      }
    }
    return null;
  }

  function insertInStock(productEl) {
    // Insertar disponibles antes del primer vendido existente
    var firstSoldOut = getFirstSoldOutInDOM();
    if (firstSoldOut) {
      productContainer.insertBefore(productEl, firstSoldOut);
    } else {
      productContainer.appendChild(productEl);
    }
  }

  function insertSoldOut(productEl) {
    // Vendidos siempre al final
    productContainer.appendChild(productEl);
  }

  function loadNextPage() {
    if (!nextPageUrl || loading) {
      console.log('[InfiniteScroll] No hay nextPageUrl o ya se está cargando.');
      return;
    }

    loading = true;
    console.log('[InfiniteScroll] Cargando URL:', nextPageUrl);

    var loader = document.querySelector('#FoodlyInfiniteLoader');
    if (loader) loader.style.display = 'block';

    fetch(nextPageUrl)
      .then(function (response) {
        console.log('[InfiniteScroll] Status respuesta:', response.status);
        if (!response.ok) throw new Error('Error al cargar la siguiente página');
        return response.text();
      })
      .then(function (html) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // ✅ En la página siguiente también buscamos #gridContainer y #FoodlyNextPage
        var newContainer = tempDiv.querySelector('#gridContainer');
        var newNextElem = tempDiv.querySelector('#FoodlyNextPage');

        console.log('[InfiniteScroll] newContainer encontrado (#gridContainer):', !!newContainer);
        console.log('[InfiniteScroll] newNextElem encontrado:', !!newNextElem);

        if (newContainer) {
          // Tomamos SOLO los productos (div.product)
          var newProducts = Array.prototype.slice.call(newContainer.querySelectorAll('.product'));
          console.log('[InfiniteScroll] Productos nuevos encontrados:', newProducts.length);

          var newForms = [];
          var inStock = [];
          var soldOut = [];

          newProducts.forEach(function (productEl) {
            // forms para initAddToCard
            var formsInProduct = productEl.querySelectorAll('.js-form-cart-alt');
            if (formsInProduct.length) {
              newForms = newForms.concat(Array.prototype.slice.call(formsInProduct));
            }

            if (isSoldOutProduct(productEl)) {
              soldOut.push(productEl);
            } else {
              inStock.push(productEl);
            }
          });

          // ✅ Insertar disponibles ANTES del primer vendido ya existente
          inStock.forEach(function (productEl) {
            insertInStock(productEl);
          });

          // ✅ Insertar vendidos al final (global)
          soldOut.forEach(function (productEl) {
            insertSoldOut(productEl);
          });

          // ✅ Re-inicializar AJAX add to cart en forms nuevos
          if (typeof initAddToCard === 'function' && newForms.length) {
            console.log('[InfiniteScroll] Re-inicializando initAddToCard en', newForms.length, 'formularios nuevos');
            initAddToCard(newForms);
          } else {
            console.log('[InfiniteScroll] initAddToCard no encontrada o sin nuevos forms');
          }
        }

        // Siguiente URL
        if (newNextElem && newNextElem.getAttribute('data-next-url')) {
          nextPageUrl = newNextElem.getAttribute('data-next-url');
          console.log('[InfiniteScroll] Nueva nextPageUrl:', nextPageUrl);
        } else {
          nextPageUrl = null;
          console.log('[InfiniteScroll] No hay más páginas.');
          window.removeEventListener('scroll', onScroll);
        }
      })
      .catch(function (error) {
        console.error('[InfiniteScroll] Error:', error);
      })
      .finally(function () {
        loading = false;
        if (loader) loader.style.display = 'none';
      });
  }

  function onScroll() {
    var scrollPosition = window.innerHeight + window.scrollY;
    var threshold = document.body.offsetHeight - 500;
    if (scrollPosition >= threshold) loadNextPage();
  }

  // Loader visual
  var loaderDiv = document.createElement('div');
  loaderDiv.id = 'FoodlyInfiniteLoader';
  loaderDiv.style.display = 'none';
  loaderDiv.style.textAlign = 'center';
  loaderDiv.style.padding = '20px 0';
  loaderDiv.innerText = 'Cargando más productos...';
  productContainer.parentNode.appendChild(loaderDiv);

  window.addEventListener('scroll', onScroll);
});
